import { useLayoutEffect, useRef } from 'react';
import { clearHistoryRepeat, readHistoryRepeat } from '../../bridge/history-repeat';
import { bindStudioPaint } from '../studio/paint';
import { stageProjects, takeProjects, unitPer100, type ProjectsEntry } from './projects-entry';

/** Сценарий из «Студии» или «Текста» (APP-SPEC-5 §5 «Входы»): строкой (как зовёт StudioScreen) или объектом {text, speakers, name, price} */
export function openProjectsWith(value: string | ProjectsEntry) {
  stageProjects(value);
  location.hash = '#projects';
}

type ScriptScreen = {
  open(host: HTMLElement, o: { project?: number; text?: string; speakers?: ProjectsEntry['speakers']; name?: string; unit?: number }): void;
  close(): void;
};

/** Раздел «Проекты»: экран шаблона «Озвучка проектов» в своём #studio (стили экрана привязаны к нему).
    Повтор из «Истории» открывает существующий проект; синтез запускается только явным действием. */
export function Projects() {
  const host = useRef<HTMLElement>(null);
  useLayoutEffect(() => {
    const el = host.current;
    const screen = (window as unknown as { BotScript?: ScriptScreen }).BotScript;
    if (!el || !screen) return;
    const repeat = readHistoryRepeat('projects');
    if (repeat) clearHistoryRepeat();
    const entry = takeProjects() ?? (repeat?.text ? { text: repeat.text } : null);
    const releasePaint = bindStudioPaint(true, el);
    const unit = unitPer100(entry?.price);
    screen.open(el, {
      project: repeat?.project_id,
      text: entry?.text || undefined,
      ...(entry?.text && entry.speakers?.length ? { speakers: entry.speakers } : {}),
      ...(entry?.text && entry.name ? { name: entry.name } : {}),
      ...(unit ? { unit } : {}),
    });
    return () => {
      screen.close();
      releasePaint();
    };
  }, []);
  return <main ref={host} id="studio" className="pg st ap" />;
}
